<template>
	<div class="fd-view-column" :draggable="true" @dragstart="dragStart" @dragend="dragEnd" :style="itemStyle">{{ column.name }}</div>
</template>

<script setup lang="ts">
import {ref, computed, type CSSProperties} from "vue";
import {ColumnListItem} from "@t/agenda/Columns.ts";

const props = defineProps<{
	column: ColumnListItem
}>();

/** Item is being dragged */
const dragged = ref<boolean>(false);
const itemStyle = computed<CSSProperties>(() => {
	if (dragged.value) {
		return { opacity: 0.25 };
	}
});

function dragStart(e: DragEvent) {
	dragged.value = true;
	console.log("dragStart "+props.column.name);
	e.dataTransfer.effectAllowed = "move";
	e.dataTransfer.setData("text/plain", props.column.name + " ("+props.column.value+")");
	// e.dataTransfer.setData("application/json", JSON.stringify(props.column));
	e.dataTransfer.setData("column_id", props.column.value);
}

function dragEnd(e: DragEvent) {
	dragged.value = false;
	console.log("Drop effect "+props.column.name+" is "+e.dataTransfer.dropEffect);
}

</script>

<style>
.fd-view-column {
	background-color: var(--pill-bg);
	color: var(--pill-fg);
	box-shadow: var(--pill-shadow);
	padding: 2px 8px;
	line-height: var(--input-height);
	border-radius: var(--button-radius);
	cursor: move;

	&:hover {
		background-color: var(--pill-bg-hover);
	}
}
</style>